module.exports = __webpack_public_path__ + "media/friends.dbf59a39.mp4";